angular.module('zc.commonApi')

.factory 'Incentive', ($filter, $q, $resource, BaseProjectCrudService) ->
  class Incentive extends BaseProjectCrudService

  new Incentive(
    $resource
    $q
    "/api/projects/:projectId/incentives/:id"
    "incentive"
    "incentives"
    request: (data) ->
      if data.incentives
        for incentive in data.incentives
          incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', incentive.start_at) if incentive.start_at
          incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', incentive.end_at) if incentive.end_at
      else if data.incentive
        data.incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.start_at) if data.incentive.start_at
        data.incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.end_at) if data.incentive.end_at

      angular.toJson(data)

    response: (data) ->
      data = angular.fromJson data
      if data.incentives
        for incentive in data.incentives
          incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at) if incentive.start_at
          incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at) if incentive.end_at
      else if data.incentive
        data.incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.start_at) if data.incentive.start_at
        data.incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.end_at) if data.incentive.end_at
      data
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/incentive.service.coffee